"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateRangeSidebar = exports.useDateRangeSidebar = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Stack_1 = require("../../components/Stack");
var R = __importStar(require("../../utils/ramda"));
var ReactIs = __importStar(require("react-is"));
var useDateRangeSidebar = function (sections) {
  var _a = __read((0, react_1.useState)(sections), 2),
    sidebarSections = _a[0],
    setSidebarSections = _a[1];
  var _b = __read((0, react_1.useState)(sections), 2),
    appliedSections = _b[0],
    setAppliedSections = _b[1];
  var setSidebarSelection = function (sectionId, selectedOption) {
    setSidebarSections(function (prev) {
      return R.editListItem({
        selectedItem: selectedOption
      }, function (s) {
        return s.id === sectionId;
      }, prev);
    });
  };
  var onCancelSidebar = function () {
    return setSidebarSections(appliedSections);
  };
  var onApplySidebar = function () {
    return setAppliedSections(sidebarSections);
  };
  var forceApplySidebar = function (sections) {
    setSidebarSections(sections);
    setAppliedSections(sections);
  };
  var isSidebarApplied = R.equals(sidebarSections, appliedSections);
  return {
    isSidebarApplied: isSidebarApplied,
    sidebarSections: sidebarSections,
    setSidebarSelection: setSidebarSelection,
    setSidebarSections: setSidebarSections,
    onCancelSidebar: onCancelSidebar,
    onApplySidebar: onApplySidebar,
    forceApplySidebar: forceApplySidebar
  };
};
exports.useDateRangeSidebar = useDateRangeSidebar;
var DateRangeSidebar = function (_a) {
  var sections = _a.sections,
    setSelected = _a.setSelected;
  if (R.isNothing(sections)) {
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
  }
  return (0, jsx_runtime_1.jsx)("div", __assign({
    className: "vsx-date-range-picker-sidebar"
  }, {
    children: sections.map(function (sect) {
      var _a;
      return (0, jsx_runtime_1.jsxs)(Stack_1.Stack, __assign({
        gap: "medium",
        role: "menubar"
      }, {
        children: [sect.title && (0, jsx_runtime_1.jsx)("div", __assign({
          className: "sidebar-header"
        }, {
          children: sect.title
        })), (_a = sect.items) === null || _a === void 0 ? void 0 : _a.map(function (item, index) {
          return (0, jsx_runtime_1.jsx)(RenderSidebarItem, {
            item: item,
            sectionId: sect.id,
            sectionSelected: sect.selectedItem,
            setSelected: setSelected
          }, index);
        })]
      }), sect.id);
    })
  }));
};
exports.DateRangeSidebar = DateRangeSidebar;
var RenderSidebarItem = function (_a) {
  var _b;
  var item = _a.item,
    sectionId = _a.sectionId,
    sectionSelected = _a.sectionSelected,
    setSelected = _a.setSelected;
  if (ReactIs.isElement(item)) {
    return (0, jsx_runtime_1.jsx)("div", __assign({
      className: "sidebar-item"
    }, {
      children: item
    }));
  }
  var radio = item;
  var id = "".concat(sectionId, "-").concat(radio.id);
  return (0, jsx_runtime_1.jsxs)("div", __assign({
    className: "sidebar-item",
    role: "menuitem"
  }, {
    children: [(0, jsx_runtime_1.jsx)("input", {
      id: id,
      className: "sidebar-radio",
      type: "radio",
      role: "menuitemradio",
      name: sectionId,
      checked: sectionSelected === radio.id,
      onChange: function () {
        radio.onSelect();
        setSelected && setSelected(sectionId, radio.id);
      }
    }), (0, jsx_runtime_1.jsx)("label", __assign({
      className: "sidebar-radio-label",
      htmlFor: id
    }, {
      children: (_b = radio.label) !== null && _b !== void 0 ? _b : radio.id
    }))]
  }));
};